export default __webpack_public_path__ + "static/media/hht1_ep04_book_wp_02.453f2d4b.jpg";